export const OgreAudioData = {
    global: {
        tempo: 78,
        signature: [6, 8],
    },
    voiceover: {
        id: "ogre-voiceover",
    },
    sharedLoops: [
        {
            name: "harp",
            volume: -16,
            samplePool: ["harp"],
            length: "4m",
            velocity: 0.8,
        },
        {
            name: "celeste",
            volume: -12,
            samplePool: ["celeste"],
            length: "4m",
            velocity: 0.8,
        },
        {
            name: "weirdness",
            volume: -16,
            samplePool: ["weirdness2", "weirdness3", "weirdness4"],
            length: "8m",
            velocity: 0.8,
        },
        {
            name: "pizzicato",
            volume: -3,
            samplePool: ["pizzicato"],
            length: "8m",
            velocity: 0.8,
        },
        {
            name: "woodwind",
            volume: -12,
            samplePool: ["bassoons", "clarinets"],
            length: "8m",
            velocity: 0.8,
        },
        {
            name: "moog",
            volume: -12,
            samplePool: ["moog"],
            length: "4m",
            velocity: 0.8,
        },
        {
            name: "triangle",
            volume: -18,
            samplePool: ["triangle"],
            length: "8m",
            startOffset: "3:1:2",
            velocity: 0.8,
        },
        {
            name: "timpani",
            volume: -16,
            samplePool: ["timpani"],
            length: "8m",
            velocity: 0.8,
        }
    ],
    scenes: [
        // 0: TITLES
        {
            name: "Intro",
            tracks: [
                { group: "harp", volume: -9 },
            ],
            fadeInDuration: 2,
            fadeOutDuration: 8,
            resetTransport: true,
        },
        {
            name: "Camera 2",
            tracks: [
                { group: "harp", volume: -9 },
                { group: "celeste", volume: -20 },
                { group: "triangle", volume: -12 },
                { group: "weirdness", volume: -18, sampleIndex: [0] },
            ],
            fadeInDuration: 2,
            fadeOutDuration: 8,
        },
        {
            name: "Camera 3",
            tracks: [
                { group: "harp", volume: -12 },
                { group: "celeste", volume: -20 },
                { group: "woodwind", volume: -12, randomOrder: true },
                { group: "triangle", volume: -6 },
                { group: "timpani", volume: -6 },
                { group: "weirdness", volume: -20, sampleIndex: [0] },
            ],
            fadeInDuration: 2,
            fadeOutDuration: 8,
        },
        {
            name: "Boy on 1st slope",
            tracks: [
                { group: "pizzicato", volume: -3 },
                { group: "weirdness", volume: -18, sampleIndex: [1, 2] },
            ],
            fadeInDuration: 2,
            fadeOutDuration: 3,
        },
        {
            name: "Boy Looking into tunnel",
            tracks: [
                { group: "woodwind", volume: -12, randomOrder: true },
                { group: "weirdness", volume: -12 },
                {
                    samplePool: ["tuba"],
                    length: "8m",
                    velocity: 0.5,
                },
                {
                    samplePool: ["marimba-reverb"],
                    length: "4m",
                    velocity: 0.7,
                },
            ],
            fadeInDuration: 2,
            fadeOutDuration: 8,
            loopsVolume: -6,
        },
        {
            name: "Boy distant",
            tracks: [
                { group: "weirdness", volume: -20, randomOrder: true },
                {
                    samplePool: ["glockenspiel"],
                    volume: -12,
                    length: "4m",
                    velocity: 0.6,
                },
            ],
            fadeInDuration: 2,
            fadeOutDuration: 8,
        },
        {
            name: "Boy on 2nd slope",
            tracks: [
                { group: "pizzicato", volume: -6 },
                { group: "weirdness", volume: -16, sampleIndex: [0] },
                { group: "moog", volume: -20 },
            ],
            fadeInDuration: 2,
            fadeOutDuration: 8,
        },
        {
            name: "Ogre",
            tracks: [
                { group: "timpani", volume: -3 },
                { group: "moog", volume: -16 },
                { group: "woodwind", volume: -24 },
                { group: "weirdness", volume: -12, randomOrder: true },
                {
                    samplePool: ["flutes"],
                    length: "8m",
                    velocity: 0.4,
                },
                {
                    samplePool: ["piccolo"],
                    length: "8m",
                    velocity: 0.4,
                },
            ],
            fadeInDuration: 2,
            fadeOutDuration: 8,
        },
        {
            name: "Ogre High",
            tracks: [
                { group: "triangle" },
                { group: "celeste", volume: -32 },
                { group: "timpani", volume: -3 },
                { group: "moog", volume: -16 },
                { group: "weirdness", volume: -12, sampleIndex: [1] },
            ],
            fadeInDuration: 2,
            fadeOutDuration: 8,
        },
        {
            name: "Ogre Final",
            tracks: [
                { group: "harp", volume: -12 },
                { group: "triangle" },
                { group: "moog", volume: -16 },
                { group: "weirdness", volume: -16 },
            ],
            fadeInDuration: 2,
            fadeOutDuration: 8,
        },
    ]
};
